export default __webpack_public_path__ + "static/media/Background_00198.2b35c14f.png";